import * as React from 'react';

/**
 * How much a filter pill may say about its selection. `full` lists up to two
 * values; `compact` names one and counts beyond that, for places with no
 * room to grow, such as the Filters panel.
 */
export type FilterPillDensity = 'full' | 'compact';

const FilterPillDensityContext = React.createContext<FilterPillDensity>('full');

export const FilterPillDensityProvider = FilterPillDensityContext.Provider;

export function useFilterPillDensity(): FilterPillDensity {
  return React.useContext(FilterPillDensityContext);
}
